import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import { GlobalContext } from "common/GlobalContext"
import NextLink from "common/NextLink"
import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import { useContext } from "react"

const Styled = {
  Wrapper: styled.div`
    text-align: left; /* flipped by mui */
    margin: 20px 15px;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 40px 0;
    }
  `,
  Sections: styled.div`
    display: flex;
    gap: 15px;

    ${(p) => p.theme.breakpoints.down("sm")} {
      flex-wrap: wrap;
    }
  `,
  Section: styled.div`
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: calc((100% - 15px) / 2);
    }
    ${(p) => p.theme.breakpoints.up("md")} {
      flex: 1;
    }
  `,
  Title: styled(Typography)``,
  SubTitle: styled(Typography)`
    margin: 15px 0 10px;
    font-size: 18px;
    color: ${(p) => p.theme.colors.marine};
    font-weight: bold;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 30px 0 10px;
      font-size: 22px;
    }
  `,
  Link: styled.a`
    display: block;
    font-size: 14px;
    line-height: 2;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
    }
  `,
}

export const getStaticProps = StaticPropsFactory("sitemap")

const SiteMap = ({ seo }: StaticPropsFactoryProps) => {
  const { links } = useContext(GlobalContext)
  const sections = [
    [links.Homepage, links.ContactUs],
    [links.ParentModels],
    [links.CustomerService],
    [links.About],
  ]

  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Container>
        <Styled.Title variant="h1">מפת אתר</Styled.Title>
        <Styled.Sections>
          {sections.map((section, i) => (
            <Styled.Section key={i}>
              {section.map((nav, i) => (
                <div key={i}>
                  <Styled.SubTitle>{nav.title}</Styled.SubTitle>
                  {typeof nav.link == "string" && (
                    <NextLink href={nav.link} passHref>
                      <Styled.Link href={nav.link}>{nav.title}</Styled.Link>
                    </NextLink>
                  )}
                  {typeof nav.link != "string" &&
                    nav.link.map((item, i) => (
                      <NextLink key={i} href={item.link} passHref>
                        <Styled.Link href={item.link}>{item.title}</Styled.Link>
                      </NextLink>
                    ))}
                </div>
              ))}
            </Styled.Section>
          ))}
        </Styled.Sections>
      </Container>
    </Styled.Wrapper>
  )
}

export default SiteMap
